import { useInfiniteQuery as useInfiniteQueryReact } from 'react-query';

import { GetInfiniteQueryResult } from 'coreOld/types';
import { concatArrays } from 'coreOld/utils';

export const useInfiniteQuery = <T>(
  fetchData,
  queryKey,
  requestPayload?,
  enabled = true,
  onSuccess?
): GetInfiniteQueryResult<T> => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isFetched,
    isFetching,
    isError,
    refetch,
    error,
  } = useInfiniteQueryReact(
    [queryKey, requestPayload],
    ({ pageParam: page = 1, signal }) => fetchData({ ...requestPayload, page }, signal),
    {
      getNextPageParam: (lastPage, page) => {
        if (page.length >= lastPage.count / requestPayload?.pageSize) {
          return undefined;
        }

        return page.length + 1;
      },
      onSuccess,
      enabled,
    }
  );

  const pageRecords = data?.pages.map((page) => page.records);
  const currentPage = data?.pages?.length;
  const totals = data?.pages[0].totals;
  const count = data?.pages[0].count;

  return {
    records: concatArrays(pageRecords) ?? [],
    isLoading,
    isFetched,
    isFetching,
    isFetchingNextPage,
    isError,
    statusCode: (error as any)?.response?.status ?? null,
    hasNextPage,
    fetchNextPage,
    refetch,
    totals,
    count,
    currentPage,
  };
};
